import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CommonService } from "../../../../services/common.service";
import { AreaService } from "../../../../services/area.service";

@Component({
  selector: "page-area-city-detail",
  templateUrl: "./index.component.html",
})
export class PageAreaCityDetailComponent implements OnInit {
  public moment: any;
  public _: any;

  public city: string;
  public town: string;
  public areaData: any;

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  constructor(
    public activatedRoute: ActivatedRoute,
    public commonService: CommonService,
    public areaService: AreaService
  ) {
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
  }

  async ngOnInit() {
    /* SHOW LOADER */
    this.commonService.showPageLoader("読み込み中...");

    this.city = this.activatedRoute.snapshot.paramMap.get("city");

    this.areaData = await this.areaService.getAreaDetails({
      city: this.city ? this.city : "",
    });

    if (this._.isEmpty(this.areaData)) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pageHomeNoParam
      );
    }

    /* SET PAGE TITLE */
    this.commonService.setTitle(
      `【最安値】${this.areaData.area.MDivision.name} 夜行・高速バスを出発地から探す|バス格安予約の`
    );

    /* HIDE LOADER */
    this.commonService.hidePageLoader();
  }
}
